import { TourConfig } from '@/components/tour/types/tour'

export const tourConfig: TourConfig = {
  version: '1.0.0',
  initialSteps: [
    {
      selector: '#new-sidebar',
      content: 'Melhoramos a navegação lateral',
      position: 'right',
    },
    {
      selector: '#sidebar-toggle',
      content: 'Agora você pode expandir e contrair a barra lateral',
      position: 'right',
    },
    {
      selector: '#search_availability_form',
      content:
        'Melhoramos a busca de disponibilidade para você encontrar mais rápido o que precisa',
      position: 'bottom',
    },
    {
      selector: '#more_fields_button',
      content:
        'Ocultamos alguns campos para você ter uma experiência mais limpa, mas você pode expandir para ver mais opções clicando aqui',
      position: 'bottom',
    },
  ],
  delayedSteps: {
    'search-results': [
      {
        selector: '#new-avail-layout',
        content: 'Nova visualização da lista de resultados',
        position: 'bottom',
      },
    ],
  },
}
